import { Typography, TYPOGRAPHY_COLORS } from 'shared';

import { Badge, BADGE_COLORS } from 'shared/components/Badge';
import { formatDuration } from 'shared/utils/formatDuration';

type ChatMessageAudioDurationProps = {
  duration: number;
  color: string;
  bgColor: string;
};

export const ChatMessageAudioDuration = ({
  duration,
  color,
  bgColor,
}: ChatMessageAudioDurationProps) => (
  <Badge colorPalette={bgColor as BADGE_COLORS} size="sm">
    <Typography
      color={color as TYPOGRAPHY_COLORS}
      type="meta"
      fontWeight="medium"
    >
      {formatDuration(duration)}
    </Typography>
  </Badge>
);
